// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .budget-card {
  background: #fff;
  border-radius: 12px;
  padding: 18px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
  width: 300px;
}

.budget-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.budget-header h4 {
  margin: 0;
  font-size: 18px;
}

.budget-type {
  font-size: 13px;
  color: gray;
}

.budget-limit {
  margin-top: 10px;
  font-size: 13px;
  color: #777;
}

.budget-bar {
  background: #e5e5e5;
  height: 10px;
  border-radius: 8px;
  margin-top: 12px;
  overflow: hidden;
}

.budget-progress {
  height: 100%;
  background: linear-gradient(90deg,#111,#00897b);
}

.budget-footer {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
  font-size: 13px;
}

.value {
  font-weight: bold;
  margin-top: 3px;
}

.green {
  color: #0a8f6a;
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 6px;
}

.dot.black {
  background: #111;
}

.dot.green {
  background: #0a8f6a;
}

.budget-card:hover{
  transform: translateY(-3px);
  transition: 0.2s ease;
} */

.budget-card {
  background: #fff;
  border-radius: 14px;
  padding: 22px;
  box-shadow: 0 6px 18px rgba(0,0,0,0.08);
  width: 340px;
  transition: all 0.25s ease;
}

.budget-card:hover{
  transform: translateY(-5px);
  box-shadow: 0 10px 24px rgba(0,0,0,0.12);
}

.budget-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.budget-header h4 {
  margin: 0;
  font-size: 19px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.budget-type {
  font-size: 13px;
  color: #6b7280;
  font-weight: 500;
}

.budget-limit {
  margin-top: 12px;
  font-size: 14px;
  color: #555;
  display: flex;
  align-items: center;
  gap: 4px;
}

.budget-bar {
  background: #e5e5e5;
  height: 12px;
  border-radius: 8px;
  margin-top: 14px;
  overflow: hidden;
}

.budget-progress {
  height: 100%;
  background: linear-gradient(90deg,#111,#00897b);
  border-radius: 8px;
}

.budget-footer {
  display: flex;
  justify-content: space-between;
  margin-top: 18px;
  font-size: 13px;
}

.value {
  font-weight: 600;
  margin-top: 4px;
  font-size: 15px;
}

.green {
  color: #0a8f6a;
}

.dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 6px;
}

.dot.black {
  background: #111;
}

.dot.green {
  background: #0a8f6a;
}`, "",{"version":3,"sources":["webpack://./src/Pages/ap_auto_app/Charts/Budget/BudgetCard.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA8EG;;AAEH;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,uCAAuC;EACvC,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,+CAA+C;EAC/C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* .budget-card {\n  background: #fff;\n  border-radius: 12px;\n  padding: 18px;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.08);\n  width: 300px;\n}\n\n.budget-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.budget-header h4 {\n  margin: 0;\n  font-size: 18px;\n}\n\n.budget-type {\n  font-size: 13px;\n  color: gray;\n}\n\n.budget-limit {\n  margin-top: 10px;\n  font-size: 13px;\n  color: #777;\n}\n\n.budget-bar {\n  background: #e5e5e5;\n  height: 10px;\n  border-radius: 8px;\n  margin-top: 12px;\n  overflow: hidden;\n}\n\n.budget-progress {\n  height: 100%;\n  background: linear-gradient(90deg,#111,#00897b);\n}\n\n.budget-footer {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 15px;\n  font-size: 13px;\n}\n\n.value {\n  font-weight: bold;\n  margin-top: 3px;\n}\n\n.green {\n  color: #0a8f6a;\n}\n\n.dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  display: inline-block;\n  margin-right: 6px;\n}\n\n.dot.black {\n  background: #111;\n}\n\n.dot.green {\n  background: #0a8f6a;\n}\n\n.budget-card:hover{\n  transform: translateY(-3px);\n  transition: 0.2s ease;\n} */\n\n.budget-card {\n  background: #fff;\n  border-radius: 14px;\n  padding: 22px;\n  box-shadow: 0 6px 18px rgba(0,0,0,0.08);\n  width: 340px;\n  transition: all 0.25s ease;\n}\n\n.budget-card:hover{\n  transform: translateY(-5px);\n  box-shadow: 0 10px 24px rgba(0,0,0,0.12);\n}\n\n.budget-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.budget-header h4 {\n  margin: 0;\n  font-size: 19px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.budget-type {\n  font-size: 13px;\n  color: #6b7280;\n  font-weight: 500;\n}\n\n.budget-limit {\n  margin-top: 12px;\n  font-size: 14px;\n  color: #555;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.budget-bar {\n  background: #e5e5e5;\n  height: 12px;\n  border-radius: 8px;\n  margin-top: 14px;\n  overflow: hidden;\n}\n\n.budget-progress {\n  height: 100%;\n  background: linear-gradient(90deg,#111,#00897b);\n  border-radius: 8px;\n}\n\n.budget-footer {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 18px;\n  font-size: 13px;\n}\n\n.value {\n  font-weight: 600;\n  margin-top: 4px;\n  font-size: 15px;\n}\n\n.green {\n  color: #0a8f6a;\n}\n\n.dot {\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  display: inline-block;\n  margin-right: 6px;\n}\n\n.dot.black {\n  background: #111;\n}\n\n.dot.green {\n  background: #0a8f6a;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
